import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'email',
    'emailError',
    'password',
    'passwordError',
    'passwordConfirmation',
    'passwordConfirmationError',
    'lodgeId',
    'lodgeError',
  ]

  connect() {
    this.minPasswordLength = parseInt(this.passwordTarget?.dataset.minLength || '6', 10)
  }

  validateField(event) {
    const el = event.currentTarget
    switch (el) {
      case this.emailTarget:
        this.validateEmail()
        break
      case this.passwordTarget:
        this.validatePassword()
        this.validatePasswordConfirmation() // keep confirm in sync
        break
      case this.passwordConfirmationTarget:
        this.validatePasswordConfirmation()
        break
      default:
        break
    }
  }

  validateForm(event) {
    const results = [
      this.validateEmail(),
      this.validatePassword(),
      this.validatePasswordConfirmation(),
      this.validateLodge(),
    ]
    if (results.includes(false)) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  validateEmail() {
    const value = (this.emailTarget?.value || '').trim()
    const valid = value.length > 0 && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
    this.renderValidity(
      this.emailTarget,
      this.emailErrorTarget,
      valid,
      valid ? '' : 'Enter a valid email address',
    )
    return valid
  }

  validatePassword() {
    const value = this.passwordTarget?.value || ''
    const valid = value.length >= this.minPasswordLength
    this.renderValidity(
      this.passwordTarget,
      this.passwordErrorTarget,
      valid,
      valid ? '' : `Password must be at least ${this.minPasswordLength} characters`,
    )
    return valid
  }

  validatePasswordConfirmation() {
    const pwd = this.passwordTarget?.value || ''
    const conf = this.passwordConfirmationTarget?.value || ''
    const valid = conf.length > 0 && pwd === conf
    this.renderValidity(
      this.passwordConfirmationTarget,
      this.passwordConfirmationErrorTarget,
      valid,
      valid ? '' : 'Passwords do not match',
    )
    return valid
  }

  validateLodge() {
    const value = (this.lodgeIdTarget?.value || '').trim()
    const valid = value.length > 0
    this.renderValidity(
      null,
      this.lodgeErrorTarget,
      valid,
      valid ? '' : 'Please select your lodge from the list',
    )
    return valid
  }

  renderValidity(inputEl, errorEl, isValid, message) {
    if (inputEl) {
      inputEl.classList.toggle('outline-red-500', !isValid)
      inputEl.classList.toggle('focus:outline-red-600', !isValid)
    }
    if (errorEl) {
      errorEl.textContent = message || ''
      errorEl.classList.toggle('hidden', isValid)
    }
  }
}
